import { storeToRefs } from 'pinia';
import { nextTick } from 'vue';
import { Route } from 'vue-router';
import { getFromSessionStorage } from '@/apps/order/helper';
import OrderAPI from '@/apps/order/classes/api/OrderAPI';

import { useOrdersCreateCategoriesStore } from '@/apps/order/stores/ordersCreate';

import CategoryInterface from '@/apps/order/interfaces/CategoryInterface';

let alreadyFetched = false;

const hasCategories = async (to: Route): Promise<void> => new Promise<void>((resolve, reject) => {
  const ctx = to.meta?.ctx;
  nextTick(async () => {
    try {
      const categoriesStore = useOrdersCreateCategoriesStore();
      const { categories, isDynamicPower } = storeToRefs(categoriesStore);

      if (categories.value !== undefined) {
        resolve();
        return;
      }

      if (!alreadyFetched) {
        categories.value = getFromSessionStorage<CategoryInterface[]>(`${ctx}.categories`);

        if (categories.value === undefined) {
          await OrderAPI.fetchCategories().then((fetchedCategories) => {
            categories.value = fetchedCategories;
          });
        }

        isDynamicPower.value = getFromSessionStorage<boolean>(`${ctx}.isDynamicPower`) || false;

        alreadyFetched = true;
      }

      if (categories.value === undefined) {
        reject(new Error('missing categories'));
        return;
      }

      resolve();
    } catch (e) {
      reject(new Error(['fetch categories failed', e].join(' ')));
    }
  });
});

export default hasCategories;
